"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChildrenWidth = useChildrenWidth;
var _react = require("react");
/**
 * useChildrenWidth
 * Calculates the sum of widths of all children of the targetRef,
 * excluding children with a given attribute (default: 'data-no-overflow').
 * Includes the target's padding and gap (horizontal or vertical based on orientation).
 *
 * @param props.targetRef - React ref to the target DOM element
 * @param props.orientation - 'horizontal' (default) or 'vertical'. Determines which paddings and gap to use.
 * @param props.skipAttribute - Attribute name to skip children (default: 'data-no-overflow')
 * @returns The total width (or height, if vertical) of the children, including target's padding and gap.
 */
function useChildrenWidth(props) {
  const {
    targetRef,
    orientation = 'horizontal',
    skipAttribute = 'data-no-overflow'
  } = props;
  const getTargetStyles = () => {
    var _a;
    if (!(targetRef === null || targetRef === void 0 ? void 0 : targetRef.current)) return {
      padding: 0,
      gap: 0
    };
    const styles = ((_a = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, targetRef.current)) || {};
    const padding = orientation === 'horizontal' ? parseInt(styles['padding-left'], 10) + parseInt(styles['padding-right'], 10) : parseInt(styles['padding-top'], 10) + parseInt(styles['padding-bottom'], 10);
    const gap = parseInt(styles['column-gap'], 10);
    return {
      padding: Number.isNaN(padding) ? 0 : padding,
      gap: Number.isNaN(gap) ? 0 : gap
    };
  };
  const getChildrenWidth = (0, _react.useCallback)(() => {
    if (!targetRef.current) return 0;
    let totalWidth = 0;
    const children = Array.from(targetRef.current.children).filter(child => child instanceof HTMLElement && !(skipAttribute && child.hasAttribute(skipAttribute)));
    children.forEach(child => {
      if (!(child instanceof HTMLElement)) return;
      totalWidth += child.offsetWidth;
    });
    const {
      padding,
      gap
    } = getTargetStyles();
    // Add gaps between children (n-1 gaps)
    const totalGap = gap * (children.length > 1 ? children.length - 1 : 0);
    return totalWidth + padding + totalGap;
  }, [targetRef, orientation]);
  return getChildrenWidth();
}